import React from "react";
import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faInstagram,
  faFacebookF,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { FiMapPin, FiPhone } from "react-icons/fi";
import { phoneUS } from "../../PhoneNumber";

const Footer = () => {
  const twitter = <FontAwesomeIcon icon={faTwitter} />;
  const facebook = <FontAwesomeIcon icon={faFacebookF} />;
  const linkedin = <FontAwesomeIcon icon={faLinkedinIn} />;
  const instagram = <FontAwesomeIcon icon={faInstagram} />;

  return (
    <div className={styles.footer}>
      <div className="container">
        <div className={styles.footerInner}>
          <div className={styles.loc}>
            <h4>Office Location</h4>
            <a
              href="https://www.google.com/maps/place/5800+Ambler+Dr+Suite+119,+Mississauga,+ON+L4W+4J4,+Canada/@43.6429224,-79.6460878,17z/data=!3m1!4b1!4m5!3m4!1s0x882b38b5b5bfffff:0xac6142731de787a6!8m2!3d43.6429224!4d-79.6460878"
              target="_blank"
              rel="noreferrer"
            >
              <p className={styles.city}>
                <span className={styles.icon}>
                  <FiMapPin />
                </span>
                <span>
                  5800 Ambler Drive, Unit # 119, Mississauga, ON, L4W-4J4
                </span>
              </p>
            </a>
            <a href={`tel:${phoneUS}`}>
              <p className={styles.phone}>
                <span className={styles.icon}>
                  <FiPhone />
                </span>
                <span className={styles.cityAdress}>{phoneUS}</span>
              </p>
            </a>
          </div>
          <div className={styles.footerLinks}>
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/websailorsINC"
                  target="_blank"
                  rel="noreferrer"
                >
                  {facebook}
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/web-sailors"
                  target="_blank"
                  rel="noreferrer"
                >
                  {linkedin}
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/websailorsINC/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {instagram}
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/WebsailorsINC"
                  target="_blank"
                  rel="noreferrer"
                >
                  {twitter}
                </a>
              </li>
            </ul>
            <p className={styles.copyRights}>
              © 2024 <Link to="/">Websailors INC.</Link> - All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
